export const serviceCenters = {
  table: {
    serviceCenterName: "Service Center Name",
    serviceTypes: "Service Types",
    address: "Address",
    line:"Line",
    city:"City",
  },
  totalProviders: "Total number of Service Centers",
  serviceCenterTypes: {
    mobil_autocare: "Mobil Autocare",
    station: "Station",
    mobil_1_center: "Mobil 1 Center",
    dealer: "Dealer",
  },
};
